var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper ticket-wrapper ticket-manage-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "breadcrumbwrapper"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  })], 1), _vm.ticketData ? _c('div', {
    staticClass: "ticket-card p-4 mt-3 ticket-list-wrapper"
  }, [_c('div', {
    staticClass: "ticket-header d-flex align-items-center gap-3 flex-wrap "
  }, [_c('div', {
    staticClass: "ticket-item d-flex align-items-center gap-1"
  }, [_c('span', {
    staticClass: "itemtitle "
  }, [_vm._v("Category :")]), _c('span', {
    staticClass: "itemvalue fw-semibold clr-black"
  }, [_vm._v(_vm._s(_vm.ticketData.category.name))])]), _c('div', {
    staticClass: "ticket-item d-flex align-items-center gap-1"
  }, [_c('span', {
    staticClass: "itemtitle"
  }, [_vm._v("Status :")]), _c('div', {
    class: ['d-inline-flex align-items-center justify-content-center badgecontainer', _vm.getStatusClass(_vm.ticketData.status)]
  }, [_c('span', {
    class: ['badge-dot', _vm.ticketData.status === 1 ? 'open' : 'closed']
  }), _c('span', [_vm._v(_vm._s(_vm.getStatusText(_vm.ticketData.status)))])])]), _c('div', {
    staticClass: "ticket-item d-flex align-items-center gap-1"
  }, [_c('span', {
    staticClass: "itemtitle"
  }, [_vm._v("Opened Date :")]), _c('span', {
    staticClass: "itemvalue fw-semibold clr-black"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.ticketData.opened_date)))])])]), _vm.ticketData.status === 1 ? _c('button', {
    staticClass: "btn btn-outline-danger close-ticket-btn ms-auto d-block",
    attrs: {
      "disabled": _vm.isClosing
    },
    on: {
      "click": _vm.handleCloseTicket
    }
  }, [_c('i', {
    staticClass: "fas fa-times-circle me-1"
  }), _vm._v(" " + _vm._s(_vm.isClosing ? 'Closing...' : 'Close Ticket') + " ")]) : _vm._e(), _c('div', {
    staticClass: "complaint_section mt-4 pt-2"
  }, [_c('div', {
    staticClass: "subjectwrapper"
  }, [_c('h6', {
    staticClass: "complaintHeader fw-bold fs-16 clr-title"
  }, [_vm._v("Subject")]), _c('div', {
    staticClass: "complaintContent fs-16"
  }, [_vm._v(" " + _vm._s(_vm.ticketData.title) + " ")])]), _c('hr'), _c('div', {
    staticClass: "descriptionwrapper"
  }, [_c('h6', {
    staticClass: "complaintHeader fw-bold fs-16 clr-title"
  }, [_vm._v("Description")]), _c('div', {
    staticClass: "complaintContent fs-16",
    domProps: {
      "innerHTML": _vm._s(_vm.ticketData.details)
    }
  })])]), _c('div', {
    staticClass: "tab-wrapper mt-4"
  }, [_c('div', {
    staticClass: "tab-wrapper-btns d-inline-flex align-items-center gap-1 flex-wrap"
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('button', {
      key: index,
      staticClass: "tab-btn border-0 d-flex align-items-center gap-2",
      class: {
        active: _vm.activeTab === tab
      },
      on: {
        "click": function click($event) {
          return _vm.setActiveTab(tab);
        }
      }
    }, [_c('i', {
      class: tab.icon
    }), _vm._v(" " + _vm._s(tab.title) + " ")]);
  }), 0), _c('div', {
    staticClass: "tab-content mt-4"
  }, [_vm.activeTab.component ? _c(_vm.activeTab.component, {
    tag: "component",
    attrs: {
      "ticket-data": _vm.ticketData,
      "add-comment": _vm.ticketData.status === 1,
      "format-date": _vm.formatDate
    }
  }) : _vm._e()], 1)])]) : _vm.loading ? _c('div', {
    staticClass: "text-center p-4"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]);
}]

export { render, staticRenderFns }